import React from "react"
import { useInView } from "react-intersection-observer"
import Img from "gatsby-image/withIEPolyfill"
import { ContentItem, Headline, CTA, Analytics } from "@shared"
import { css } from "@jsUtils"
import { CONSTANTS } from "@data"

const { COLORS } = CONSTANTS

const InvestorRow = props => {
  const { data, styles } = props
  const TrackedLink = Analytics("a")
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  })

  return (
    <ContentItem gridArea="article" extraClass={css(styles.row, inView && styles.ready)}>
      <section ref={ref}>
        <div className={styles.rowContent}>
          <Headline size={2} className={styles.notVis}>
            {data.name}
          </Headline>
          <div className={styles.img}>
            <TrackedLink
              ascope="IMGS"
              adata={{
                content: data.name
              }}
              href={data.link}
              target="_blank"
              rel="noreferrer"
            >
              <Img fluid={data.logo.fluid} alt={data.name} fadeIn={false} />
            </TrackedLink>
          </div>
          <p className={styles.p}>{data.description ? data.description.description : null}</p>
          <div className={styles.link}>
            {data.link ? (
              <CTA
                ascope="CTAS"
                adata="MISC.LEARN"
                ready={inView}
                to={data.link}
                color={COLORS.FLURO}
                anchor
                target="_blank"
              >
                Learn More
              </CTA>
            ) : null}
          </div>
        </div>
      </section>
    </ContentItem>
  )
}

export default InvestorRow
